<template>
  <Teleport to="body">
    <div
      class="animate-fade z-1000 fixed inset-0 flex items-center justify-center"
    >
      <div class="bg-static-black-secondary/80 fixed inset-0"></div>
      <slot>
        <FreeLoader class="relative z-10" />
      </slot>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
  import { FreeLoader } from '../../shared/ui';
</script>

<style scoped>
  .animate-fade {
    animation: fade-in 0.3s ease-in-out;
  }
  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
</style>
